import { useNavigate, useLocation } from 'react-router-dom';
import { ChangeEvent, useEffect, useState } from 'react';
import React from 'react';
import {
  ANNUAL_RENEWAL_PROCESS,
  DOC_COMP_INTEGRAL,
  HOME_SCREEN,
  NEW_DOC_COMPARISON,
} from '../../core-utils/routes';
import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  AddCheckoffList,
  AgreementSignedIcon,
  AnnualStepper,
  Breadcrumbs,
  Button,
  CardComponent,
  ConfirmationPopup,
  DeleteBadge,
  DocParameter,
  Edit,
  ProcessNotStarted,
  SortableChecklist,
  SortableTools,
  Switch,
  Trash,
  VendorSelected,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import TabSelection from '../../_components/molecules/TabSelection';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { ChecklistItem } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/SortableChecklist';
import AddCheckoffListModal from '../../_components/organisms/AddCheckoffListModal';
import properties from '../../core-utils/properties';
import { useStores } from '../../stores';
import axios from '../../core-utils/axios/axiosSetUp';
import { formatCheckoffList, updateStepStatuses } from './helper';
import { formatDate } from '../../core-utils/helper-utils/helper';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import Snackbar from '../../_components/atoms/Snackbar';
import Loader from '../../_components/molecules/Loader';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import NoCheckoffLists from '../../../public/Images/NoCheckoffLists.png';
import { ToolslistItem } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/SortableTools';
import DiscoverTune from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Icons/Discover_tune';
import { RECOMMENDED_APPS } from '../../core-utils/messages/RecommendedAppConstants';
import { ComparisonDataPros } from '../DocumentComparisonPage';
import ComparisonTable from '../../_components/atoms/ComparisonTable';
import {
  COMP_LIB_TABLE_COLUMNS,
  formatComparisonTableData,
} from '../../core-utils/helper-utils/docComparisonHelper';
import { DueDiligenceDataType } from '../../core-utils/helper-utils/recommendedAppsHelper';
import { compilationDataProps } from '../TermCompilerPage';
import { Pagination } from '@mui/material';
import NoDoc from '../../_components/atoms/Icons/NoDocuments';
import { DraftAgreementComponent } from '../../_components/organisms/DraftAgreementComponent';
import ProvisionMatrix from '../../_components/organisms/ProvisionMatrix';
import { Columns as MatrixColumns } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/MatrixTable';
import AddNotesCheckoffListModal from '../../_components/organisms/AddNotesCheckoffListModal';
import EditNotesCheckoffListModal from '../../_components/organisms/EditNotesCheckoffListModal';
import { Step } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/AnnualStepper';
import AgreementUnderReviewIcon from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Icons/AgreementUnderReview';
const useStyles = () =>
  makeStyles()(() => ({
    root: {
      width: '1182px',
      padding: '12px 0px 36px 63px',
    },
    hr: {
      width: '100%',
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      margin: '10px 0px 20px',
    },
    tabContent: {
      overflow: 'auto',
      paddingTop: '24px',
    },
    labelSubLabel: {
      backgroundColor: '#F2F4FA4D',
      padding: '8px 8px 8px 10px',
      borderRadius: '4px',
      minWidth: '361px',
    },
    details: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '20px',
    },
    button: {
      textTransform: 'none',
      backgroundColor: patientAccessTheme.palette.primary[400],
      '&:hover': {
        backgroundColor: patientAccessTheme.palette.primary[400],
      },
    },
    titleGrid: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    dateGrid: {
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      padding: '2px 10px',
      borderRadius: '4px',
      backgroundColor: patientAccessTheme.palette.status.white,
    },
    toolsMainContainer: {
      marginTop: '10px',
    },
    toolsTitle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
    },
    sortableContainer: {
      marginTop: '10px',
    },
    pagination: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    noDataGrid: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    documentTitle: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
    },
  }))();
// Default tools with all visibility set to true
const DEFAULT_TOOLS = [
  {
    title: 'Checkoff List',
    subTitle:
      'Custom checklist of items to consider during the renewal, including learnings, best practices, and internal notes.',
    visibility: true,
  },
  {
    title: 'Document Comparison',
    subTitle:
      'Side-by-side clause comparison between current and draft agreements.',
    visibility: true,
  },
  {
    title: 'Draft Agreement Analyzer',
    subTitle:
      'AI-driven review of draft vendor agreement with compliance and commercial insights.',
    visibility: true,
  },
  {
    title: 'Current Contract Observations',
    subTitle:
      'Platform-generated summary of key issues and improvement areas from current agreement.',
    visibility: true,
  },
];

const RenewalDetailsPage = () => {
  //Constants
  const location = useLocation();
  const { renewalId, serviceAgreement }: any = location?.state;
  const employerStore = useStores().employerGroupStore;
  const loginStore = useStores().loginPageStore;
  const contractStore = useStores().contractAiqStore;
  const egNid = employerStore.employerGroupResponseData.eg_nid[0];
  const email = loginStore.email;
  const navigate = useNavigate();
  const { classes } = useStyles();
  const { openSnackbar, snackbarState, handleCloseSnackBar } = useSnackbar();
  const breadcrumbItems = [
    [
      'text',
      'Home',
      {
        color: patientAccessTheme.palette.primary[500],
        fontWeight: 500,
      },
      () => {
        navigate(HOME_SCREEN);
      },
    ],
    [
      'text',
      'Annual Renewal Process',
      {
        color: patientAccessTheme.palette.primary[500],
        fontWeight: 600,
      },
      () => {
        navigate(ANNUAL_RENEWAL_PROCESS);
      },
    ],
    [
      'text',
      'View Summary',
      {
        color: patientAccessTheme.palette.text.highemphasis,
        fontWeight: 600,
      },
    ],
  ];
  const details = [
    { label: 'Vendor Name', subLabel: serviceAgreement || '-' },
    { label: 'Renewal Date', subLabel: '-' },
    { label: 'Expected Release Date', subLabel: '-' },
  ];
  const summaryColumns: MatrixColumns[] = [
    {
      header: 'Name',
      accessor: 'name',
      align: 'left',
    },
    {
      header: 'Findings',
      accessor: 'value',
      align: 'center',
    },
    {
      header: 'Proposed Corrected Language',
      accessor: 'proposed_correct_language',
      align: 'center',
    },
    {
      header: 'Minimal Acceptable Language',
      accessor: 'minimal_acceptable_language',
      align: 'center',
    },
    {
      header: 'Business Impact',
      accessor: 'business_impact',
      align: 'center',
    },
  ];
  const { card } = RECOMMENDED_APPS.DOC_COMPARISON;
  const pageLimit = 10;
  const loginPageStore = useStores().loginPageStore;

  //States
  const [toolsTabs, setToolsTabs] = useState<
    { id: string; title: string; visibility: boolean }[]
  >([]);
  const [toolsItems, setToolsItems] = useState<ToolslistItem[]>([]);
  const [renewalDetails, setRenewalDetails] = useState(details);
  const [renewal, setRenewal] = useState<any>({});
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  // Tools checklist for "Customise Contract Tools"
  const [items] = useState<ToolslistItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [tabLoading, setTabLoading] = useState<boolean>(true);
  const [checklistItems, setChecklistItems] = useState<ChecklistItem[]>([]);
  const [
    isAddCheckoffListModalOpen,
    setIsAddCheckoffListModalOpen,
  ] = useState<boolean>(false);
  const [
    isAddNotesCheckoffListModalOpen,
    setIsAddNotesCheckoffListModalOpen,
  ] = useState<boolean>(false);
  const [
    isEditNotesCheckoffListModalOpen,
    setIsEditNotesCheckoffListModalOpen,
  ] = useState<boolean>(false);
  const [editingNoteIndex, setEditingNoteIndex] = useState<number | null>(null);

  const [
    isDeleteNotesCheckoffListModalOpen,
    setIsDeleteNotesCheckoffListModalOpen,
  ] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [checkoffList, setCheckoffList] = useState<{
    name: string;
    notes: string;
  }>({
    name: '',
    notes: '',
  });
  const [
    selectedCheckoffList,
    setSelectedCheckoffList,
  ] = useState<ChecklistItem>();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [currentStepTitle, setCurrentStepTitle] = useState<string | null>(null);

  // Document Comparision States
  const [comparisonData, setComparisonData] = useState<ComparisonDataPros[]>(
    [],
  );
  const [pageCount, setPageCount] = useState(10);
  const [tablePageNumber, setTablePageNumber] = useState(1);
  const [mainLoading, setMainLoading] = useState(true);

  // Current Contract Observations
  const [summaryOfFindings, setSummaryOfFindings] = useState<any[]>([]);

  //Functions
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
  };

  const handleChangeCheckoffList = (field: 'name' | 'notes', value: string) => {
    setCheckoffList((prev) => ({ ...prev, [field]: value }));
  };

  const handleSaveCheckoffList = async () => {
    if (isEdit) {
      await editCheckoffList(selectedCheckoffList?.id!, {
        name: checkoffList?.name,
        notes: checkoffList?.notes
          ? checkoffList.notes
              .split('\n')
              .map((n) => n.trim())
              .filter((n) => n !== '')
          : [],
      });
    } else {
      await addNewCheckoffList();
    }
    setIsAddCheckoffListModalOpen(false);
    setIsEdit(false);
    setCheckoffList({ name: '', notes: '' });
    await getCheckoffLists();
  };

  const handleCheckoffListBookmark = async (id: string, checked: boolean) => {
    await editCheckoffList(id, {
      is_bookmarked: checked,
    });
    await getCheckoffLists();
    // const updatedItems = checklistItems?.map((item) =>
    //   item.id === id ? { ...item, isBookmarked: checked } : item,
    // );
    // setChecklistItems(updatedItems);
  };

  const handleCheckoffListCheck = async (id: string, checked: boolean) => {
    await editCheckoffList(id, {
      is_marked_completed: checked,
    });
    await getCheckoffLists();
  };

  const handleSortableItems = (id: string, checked: boolean) => {
    setToolsItems((prev) => {
      const updated = prev.map((item) =>
        item.id === id ? { ...item, visibility: checked } : item,
      );

      // ✅ CALL API HERE (user intent)
      updateRenewalTools(updated);

      return updated;
    });
  };

  const handleToolsReorder = (updatedItems: ToolslistItem[]) => {
    setToolsItems(updatedItems);

    // ✅ user dragged → call backend
    updateRenewalTools(updatedItems);
  };

  const handleCheckoffListEdit = (id: string) => {
    setIsEdit(true);
    const selectedCheckoffList = checklistItems?.find(
      (item) => item?.id === id,
    );
    setSelectedCheckoffList(selectedCheckoffList);
    setCheckoffList({
      name: selectedCheckoffList?.title!,
      notes: selectedCheckoffList?.notes
        ? selectedCheckoffList.notes.join('\n')
        : '',
    });

    setIsAddCheckoffListModalOpen(true);
  };

  const handleDeleteCheckofflist = async () => {
    setIsDeleteModalOpen(false);
    await deleteCheckoffList(selectedCheckoffList?.id!);
    await getCheckoffLists();
  };

  const handleClickDelete = (id: string) => {
    const selectedCheckoffList = checklistItems?.find(
      (item) => item?.id === id,
    );
    setSelectedCheckoffList(selectedCheckoffList);
    setIsDeleteModalOpen(true);
  };

  // Document Comparision Functions
  const handlePagination = (_event: ChangeEvent<unknown>, page: number) => {
    setTablePageNumber(page);
  };

  const handleRowClick = (
    eg_nid: DueDiligenceDataType['eg_nid'],
    status: DueDiligenceDataType['status'] | compilationDataProps['status'],
    contract_ids: ComparisonDataPros['contract_ids'],
    comparison_name: ComparisonDataPros['comparison_name'],
    vendor_type: ComparisonDataPros['vendor_type'],
    comparison_id: ComparisonDataPros['_id'],
  ) => {
    if (status === 'Ready') {
      navigate(DOC_COMP_INTEGRAL, {
        state: {
          comparison_name,
          vendor_type,
          doc_comparison_id: comparison_id,
        },
      });
    }
  };

  // function for steps
  const handleStepClick = (
    stepId: number,
    stepTitle: string,
    // stepStatus: string,
  ) => {
    editRenewalStatus(stepTitle);
  };

  //APIs
  const getRenewalById = async () => {
    try {
      const response = await axios.get(
        `${properties.aiqBaseUrl}${properties.renewals}${properties.getRenewalById}`,
        {
          params: {
            id: renewalId,
          },
        },
      );

      const data = response?.data?.data;
      const formattedDetails = [
        {
          label: 'Vendor Name',
          subLabel: serviceAgreement || '-',
        },
        {
          label: 'Renewal Date',
          subLabel:
            data.renewal_date && !data.renewal_date.includes('undefined')
              ? formatDate(data.renewal_date, 'DD MMMM YYYY')
              : '-',
        },
        {
          label: 'Expected Release Date',
          subLabel: (() => {
            const date = data?.expected_release_date;

            if (!date || date === 'undefined') {
              return '-';
            }

            const formatted = formatDate(date, 'DD MMMM YYYY');
            return formatted === 'Invalid date' ? '-' : formatted;
          })(),
        },
      ];

      setRenewal(data);
      setRenewalDetails(formattedDetails);
      setLoading(false);
      setTabLoading(false);
      if (
        data?.status === 'Not Started' ||
        data?.status === 'Process Not Started'
      ) {
        setCurrentStepTitle('Process Not Started');
      } else {
        setCurrentStepTitle(data?.status);
      }
    } catch (error: any) {
      openSnackbar(error.response?.data?.error, 'error', 3000);
      throw error.response?.data?.error || error;
    }
  };
  const editRenewalStatus = async (status: string) => {
    try {
      setLoading(true);
      await axios.post(
        properties?.aiqBaseUrl + properties?.renewals + '/update-renewal',
        {
          id: renewalId,
          status: status,
        },
      );

      // update UI immediately
      setCurrentStepTitle(status);
      openSnackbar('Contract status updated successfully', 'success', 3000);
      getRenewalById();
    } catch (error: any) {
      openSnackbar(
        error.response?.data?.error || 'Failed to update status',
        'error',
        3000,
      );
    } finally {
      setLoading(false);
    }
  };

  const getCheckoffLists = async () => {
    try {
      setTabLoading(true);
      const response = await axios.get(
        `${properties.aiqBaseUrl}${properties.renewals}${properties.checkoffLists}`,
        {
          params: {
            renewal_id: renewalId,
          },
        },
      );
      const data = response?.data?.data;
      const formattedData = formatCheckoffList(data);
      setChecklistItems(formattedData);
      setTabLoading(false);
    } catch (error: any) {
      openSnackbar(error.response?.data?.error, 'error', 3000);
      throw error.response?.data?.error || error;
    }
  };
  const isSummaryDisabled =
    !summaryOfFindings?.length ||
    summaryOfFindings.every(
      (item: any) => !item?.value || item.value.trim() === '',
    );

  const getSummaryOfFindings = async () => {
    setLoading(true);
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getSummaryOfFindings,
        {
          contract_id: contractStore.contractId,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          setSummaryOfFindings(data);
        }
      })
      .catch((error) => {
        setLoading(true);
        openSnackbar(error.response?.data?.error, 'error', 6000);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getRenewalToolsByEgnid = async () => {
    try {
      const response = await axios.get(
        `${properties.aiqBaseUrl}${properties.renewals}${properties.getRenewalToolsByEgnid}`,
        {
          params: { eg_nid: egNid, year: renewal?.year, month: renewal?.month },
        },
      );

      let tools = response?.data?.data?.tools || [];
      if (isSummaryDisabled) {
        tools = tools.filter(
          (tool: any) => tool.title !== 'Current Contract Observations',
        );
      }

      if (!Array.isArray(tools) || tools.length === 0) {
        tools = DEFAULT_TOOLS;
        setToolsTabs([{ id: 'overview', title: 'Overview', visibility: true }]);
        setToolsItems([]);
      }

      const visibleTools = tools.filter(
        (tool: any) => tool.visibility === true,
      );

      setToolsTabs([
        { id: 'overview', title: 'Overview', visibility: true },
        ...visibleTools.map((tool: any) => ({
          id: tool.title,
          title: tool.title,
          subTitle: tool.subTitle,
          visibility: tool.visibility,
        })),
      ]);

      setToolsItems(
        tools.map((tool: any, index: number) => ({
          id: `tool-${index}`,
          title: tool.title,
          subTitle: tool.subTitle,
          completed: false,
          visibility: tool.visibility,
        })),
      );
    } catch (error: any) {
      openSnackbar(error.response?.data?.error, 'error', 3000);
    }
  };

  const addNewCheckoffList = async () => {
    try {
      setTabLoading(true);
      await axios.post(
        `${properties.aiqBaseUrl}${properties.renewals}${properties.checkoffLists}`,
        {
          eg_nid: egNid,
          renewal_id: renewalId,
          name: checkoffList?.name,
          notes: checkoffList?.notes
            ? checkoffList.notes
                .split('\n')
                .filter((note) => note.trim() !== '')
            : [],
          createdBy: email,
        },
      );
    } catch (error: any) {
      openSnackbar(error.response?.data?.error, 'error', 3000);
      throw error.response?.data?.error || error;
    }
  };

  const editCheckoffList = async (id: string, updateData: any) => {
    try {
      setTabLoading(true);
      await axios.post(
        `${properties.aiqBaseUrl}${properties.renewals}${properties.updateCheckoffLists}`,
        {
          id: id,
          updateData,
        },
      );
    } catch (error: any) {
      openSnackbar(error.response?.data?.error, 'error', 3000);
      throw error.response?.data?.error || error;
    }
  };

  const deleteCheckoffList = async (id: string) => {
    try {
      setTabLoading(true);
      await axios.post(
        `${properties.aiqBaseUrl}${properties.renewals}${properties.deleteCheckoffLists}`,
        {
          id: id,
        },
      );
    } catch (error: any) {
      openSnackbar(error.response?.data?.error, 'error', 3000);
      throw error.response?.data?.error || error;
    }
  };

  // Notes section

  const handleAddNote = (checklistId: string) => {
    const selected = checklistItems.find((item) => item.id === checklistId);
    if (!selected) {
      return;
    }

    setSelectedCheckoffList(selected);
    setCheckoffList({
      name: selected.title,
      notes: '', // start with empty notes
    });
    setIsAddNotesCheckoffListModalOpen(true);
  };

  const addNoteToCheckoffList = async (checklistId: string, notes: string) => {
    try {
      setTabLoading(true);

      const notesArray = notes
        .split('\n')
        .map((n) => n.trim())
        .filter((n) => n !== '');

      await axios.post(
        `${properties.aiqBaseUrl}${properties.renewals}${properties.addNotes}`,
        {
          id: checklistId,
          notes: notesArray, // ✅ array
          updatedBy: email,
        },
      );

      await getCheckoffLists();
      openSnackbar('Notes added successfully', 'success', 3000);
    } catch (error: any) {
      openSnackbar(
        error.response?.data?.error || 'Something went wrong',
        'error',
        3000,
      );
    } finally {
      setTabLoading(false);
    }
  };

  const editNoteInCheckoffList = async (
    checklistId: string,
    oldNote: string,
    newNote: string,
  ) => {
    try {
      setTabLoading(true);
      await axios.post(
        `${properties.aiqBaseUrl}${properties.renewals}${properties.editNotes}`,
        {
          id: checklistId,
          oldNote,
          newNote,
          updatedBy: email,
        },
      );
      await getCheckoffLists();
      openSnackbar('Note updated successfully', 'success', 3000);
    } catch (error: any) {
      openSnackbar(
        error.response?.data?.error || 'Something went wrong',
        'error',
        3000,
      );
    } finally {
      setTabLoading(false);
    }
  };

  const deleteNoteFromCheckoffList = async (
    checklistId: string,
    note: string,
  ) => {
    try {
      setTabLoading(true);
      await axios.post(
        `${properties.aiqBaseUrl}${properties.renewals}${properties.deleteNotes}`,
        {
          id: checklistId,
          note: note,
          updatedBy: email,
        },
      );
      await getCheckoffLists();
      openSnackbar('Note deleted successfully', 'success', 3000);
    } catch (error: any) {
      openSnackbar(
        error.response?.data?.error || 'Something went wrong',
        'error',
        3000,
      );
    } finally {
      setTabLoading(false);
    }
  };

  const tabAPIcalls = () => {
    const selectedTool = toolsTabs[selectedTabIndex];
    if (!selectedTool) {
      return;
    }

    switch (selectedTool.title) {
      case 'Checkoff List':
        getCheckoffLists();
        break;
      case 'Current Contract Observations':
        getSummaryOfFindings();
        break;
      case 'Document Comparison':
        getAllComparison();
        break;
    }
  };

  // Call backend whenever toolsItems changes

  const updateRenewalTools = async (toolsItems: ToolslistItem[]) => {
    try {
      setLoading(true);
      const payload = toolsItems.map((tool) => ({
        title: tool.title,
        subTitle: tool.subTitle || '',
        visibility: tool.visibility,
      }));

       
      const response = await axios.post(
        `${properties.aiqBaseUrl}${properties.renewals}${properties.updateRenewalTools}`,
        {
          eg_nid: egNid,
          year: renewal?.year,
          month: renewal?.month,
          tools: payload,
        },
      );
      if (response.status === 200) {
        openSnackbar('Contract tools updated successfully', 'success', 3000);
        getRenewalToolsByEgnid();
      }
    } catch (error: any) {
      setLoading(true);
      openSnackbar(error.response?.data?.error, 'error', 3000);
    } finally {
      setLoading(false);
    }
  };

  // Document Comparions Api
  const getAllComparison = async () => {
    try {
      setMainLoading(true);
      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getAllComparison,
        {
          ...(loginPageStore?.isAdmin
            ? { eg_nid: loginPageStore.employerGroups }
            : {}),
          page: tablePageNumber,
          limit: pageLimit,
        },
      );
      const comparisonData = response?.data?.data || [];
      const totalCount = response?.data?.totalCount || 0;
      const formattedData = formatComparisonTableData(comparisonData);
      setComparisonData(formattedData);
      setPageCount(Math.ceil(totalCount / pageLimit));
    } catch (err) {
    } finally {
      setMainLoading(false);
    }
  };

  useEffect(() => {
    if (egNid) {
      getRenewalById();
    }
  }, [egNid]);
  useEffect(() => {
    if (renewal?.year && renewal?.month) {
      getRenewalToolsByEgnid();
    }
  }, [renewal?.year, renewal?.month]);

  useEffect(() => {
    tabAPIcalls();
  }, [selectedTabIndex, tablePageNumber]);

  // Document Comparision useEffect
  const getTabsContent = () => {
    const selectedTool = toolsTabs[selectedTabIndex];

    if (!selectedTool) {
      return null;
    }
    switch (selectedTool.id) {
      case 'overview':
        return CurrentAgreementDetails();
      case 'Checkoff List':
        return CheckOffLists();
      case 'Document Comparison':
        return DocumentComparision();
      case 'Draft Agreement Analyzer':
        return <DraftAgreementComponent />;
      case 'Current Contract Observations':
        return SummaryOfFindings();
      default:
        return <></>;
    }
  };

  const LabelSubLabel = (Label: string, subLabel: string) => {
    return (
      <Grid className={classes.labelSubLabel}>
        <Typography
          fontType="medium"
          fontSize="12px"
          textColor={patientAccessTheme.palette.text.mediumemphasis}
          lineHeight="140%"
          margin="0px 0px 8px 0px"
        >
          {Label}
        </Typography>
        <Typography
          fontType="medium"
          fontSize="14px"
          textColor={patientAccessTheme.palette.text.highemphasis}
        >
          {subLabel}
        </Typography>
      </Grid>
    );
  };

  const CurrentAgreementDetails = () => {
    const toolsToRender = toolsItems.length > 0 ? toolsItems : items; // use backend tools if available

    // steps
    const initialSteps: Step[] = [
      {
        id: 1,
        icon: <ProcessNotStarted />,
        title: 'Process Not Started',
        status: 'upcoming',
      },
      {
        id: 2,
        icon: <DocParameter />,
        title: 'RFP process',
        status: 'upcoming',
      },
      {
        id: 3,
        icon: <VendorSelected />,
        title: 'Vendor Selected for Renewal',
        status: 'upcoming',
      },
      {
        id: 4,
        icon: <AgreementUnderReviewIcon />,
        title: 'Draft Agreement Under Review',
        status: 'upcoming',
      },
      {
        id: 5,
        icon: <AgreementSignedIcon />,
        title: 'Agreement Signed & Received',
        status: 'upcoming',
      },
    ];

    // ✅ USE THE HELPER FUNCTION HERE
    const steps = updateStepStatuses(initialSteps, currentStepTitle);

    return (
      <Grid>
        <CardComponent
          mainGridStyles={{
            marginBottom: '10px',
          }}
          title=""
          body={
            <Grid>
              <AnnualStepper steps={steps} onStepClick={handleStepClick} />
            </Grid>
          }
        />

        <CardComponent
          title={
            <Typography
              fontType="medium"
              fontSize="16px"
              textColor={patientAccessTheme.palette.text.highemphasis}
              lineHeight="140%"
            >
              Current Agreement Details
            </Typography>
          }
          body={
            <Grid>
              <Grid className={classes.details}>
                {renewalDetails?.map((detail) => (
                  <Grid key={detail.label}>
                    {LabelSubLabel(detail.label, detail.subLabel)}
                  </Grid>
                ))}
              </Grid>
            </Grid>
          }
        />

        <Grid
          className={classes.toolsMainContainer}
          style={{ marginTop: '10px' }}
        >
          <CardComponent
            title={
              <Grid className={classes.toolsTitle}>
                <DiscoverTune />
                <Typography
                  fontType="medium"
                  fontSize="16px"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  lineHeight="140%"
                >
                  Customise Contract Tools
                </Typography>
              </Grid>
            }
            body={
              <Grid className={classes.sortableContainer}>
                <SortableTools
                  items={toolsToRender}
                  setItems={handleToolsReorder} // use backend state
                  onCheck={handleSortableItems}
                  renderItemAction={(item, onAction) => (
                    <Switch
                      checked={item.visibility ?? true}
                      color="primary"
                      handleChange={(e) =>
                        onAction('toggle-visibility', e.target.checked)
                      }
                    />
                  )}
                />
              </Grid>
            }
          />
        </Grid>
      </Grid>
    );
  };

  const CheckOffLists = () => {
    return (
      <CardComponent
        title="Check Off-List"
        subTitle={
          'Review contract performance across critical areas. Mark items as compliant, flag issues, or add new checks as needed before renewal.'
        }
        topRightItem={
          <Button
            label={
              <Typography
                fontType="medium"
                fontSize="14px"
                textColor={patientAccessTheme.palette.status.white}
                lineHeight="160%"
              >
                Add Check List
              </Typography>
            }
            variant="contained"
            height="auto"
            width="auto"
            startIcon={<AddCheckoffList />}
            onClick={() => {
              setIsEdit(false);
              setIsAddCheckoffListModalOpen(true);
            }}
            className={classes.button}
          />
        }
        body={
          <Grid>
            {checklistItems?.length > 0 ? (
              <SortableChecklist
                items={checklistItems}
                setItems={setChecklistItems}
                onDelete={handleClickDelete}
                onEdit={handleCheckoffListEdit}
                onCheck={handleCheckoffListCheck}
                onBookmark={handleCheckoffListBookmark}
                noteMenuItems={[
                  {
                    label: 'Edit',
                    icon: <Edit />,
                    onClick: (checklistId: string, noteIndex: number) => {
                      const selected = checklistItems.find(
                        (item) => item.id === checklistId,
                      );

                      if (
                        selected &&
                        selected.notes &&
                        selected.notes[noteIndex] !== undefined
                      ) {
                        setSelectedCheckoffList(selected);
                        setEditingNoteIndex(noteIndex);
                        setCheckoffList({
                          name: selected.title,
                          notes: selected.notes[noteIndex],
                        });
                        setIsEditNotesCheckoffListModalOpen(true);
                      }
                    },
                  },
                  {
                    label: 'Delete',
                    icon: <Trash />,
                    onClick: (checklistId: string, noteIndex: number) => {
                      const selected = checklistItems.find(
                        (item) => item.id === checklistId,
                      );
                      if (
                        selected &&
                        selected.notes &&
                        selected.notes[noteIndex] !== undefined
                      ) {
                        const noteToDelete = selected.notes[noteIndex];
                        setSelectedCheckoffList(selected);
                        setCheckoffList({
                          name: selected.title,
                          notes: noteToDelete,
                        });
                        setIsDeleteNotesCheckoffListModalOpen(true); // open modal with correct note
                      }
                    },
                  },
                ]}
                onAddNote={handleAddNote}
              />
            ) : (
              <GifWithLabels
                mainLabel={undefined}
                rootStyles={{
                  minHeight: '360px',
                }}
                subLabel={
                  <Typography
                    fontType="medium"
                    fontSize="14px"
                    textColor={patientAccessTheme.palette.text.highemphasis}
                  >
                    No lists available! Add a new check-off list.
                  </Typography>
                }
                gifUrl={NoCheckoffLists}
              />
            )}
            {isAddCheckoffListModalOpen && (
              <AddCheckoffListModal
                name={checkoffList?.name || ''}
                notes={checkoffList?.notes || ''}
                onChange={handleChangeCheckoffList}
                onSave={handleSaveCheckoffList}
                onClose={() => {
                  setIsEdit(false);
                  setIsAddCheckoffListModalOpen(false);
                  setCheckoffList({ name: '', notes: '' });
                }}
                title={isEdit ? 'Edit Checkoff List' : 'Add New Checkoff List'}
              />
            )}
            {isDeleteModalOpen && (
              <ConfirmationPopup
                icon={<DeleteBadge width="38px" height="38px" />}
                title={'Delete Checkoff List'}
                subTitle={
                  'On confirmation, Checkoff list will be deleted permanently. Are you sure?'
                }
                handleCancel={() => setIsDeleteModalOpen(false)}
                handleConfirm={handleDeleteCheckofflist}
                buttonsType="error"
              />
            )}
            {isAddNotesCheckoffListModalOpen && (
              <AddNotesCheckoffListModal
                name={checkoffList?.name || ''}
                notes={checkoffList?.notes || ''}
                onChange={handleChangeCheckoffList}
                onSave={() => {
                  if (selectedCheckoffList) {
                    addNoteToCheckoffList(
                      selectedCheckoffList.id,
                      checkoffList.notes,
                    );
                    setIsAddNotesCheckoffListModalOpen(false);
                  }
                }}
                onClose={() => {
                  setIsAddNotesCheckoffListModalOpen(false);
                  setCheckoffList({ name: '', notes: '' });
                }}
                title="Add Notes"
              />
            )}
            {isEditNotesCheckoffListModalOpen &&
              selectedCheckoffList &&
              editingNoteIndex !== null && (
                <EditNotesCheckoffListModal
                  name={checkoffList.name}
                  note={checkoffList.notes}
                  onChange={(value) =>
                    setCheckoffList((prev) => ({ ...prev, notes: value }))
                  }
                  onSave={() => {
                    editNoteInCheckoffList(
                      selectedCheckoffList.id,
                      selectedCheckoffList.notes![editingNoteIndex],
                      checkoffList.notes,
                    );
                    setIsEditNotesCheckoffListModalOpen(false);
                    setEditingNoteIndex(null);
                  }}
                  onClose={() => {
                    setIsEditNotesCheckoffListModalOpen(false);
                    setEditingNoteIndex(null);
                    setCheckoffList({ name: '', notes: '' });
                  }}
                />
              )}

            {isDeleteNotesCheckoffListModalOpen && selectedCheckoffList && (
              <ConfirmationPopup
                icon={<DeleteBadge width="38px" height="38px" />}
                title={`Do you want to delete "${checkoffList.notes}"?`}
                subTitle="On confirmation, this note will be deleted permanently."
                handleCancel={() =>
                  setIsDeleteNotesCheckoffListModalOpen(false)
                }
                handleConfirm={() => {
                  deleteNoteFromCheckoffList(
                    selectedCheckoffList.id,
                    checkoffList.notes,
                  );
                  setIsDeleteNotesCheckoffListModalOpen(false);
                }}
                buttonsType="error"
              />
            )}
          </Grid>
        }
      />
    );
  };

  const DocumentComparision = () => {
    return (
      <CardComponent
        title={
          <Grid className={classes.documentTitle}>
            <Typography
              fontSize="14px"
              fontType="semiBold"
              textColor={patientAccessTheme.palette.text.highemphasis}
            >
              {card.title}
            </Typography>
          </Grid>
        }
        subTitle={card.subTitle}
        topRightItem={
          <Button
            label="Add New Comparision"
            onClick={() => {
              navigate(NEW_DOC_COMPARISON);
            }}
            variant="contained"
            width="auto"
          />
        }
        body={
          <Grid
            style={{
              marginTop: '10px',
            }}
          >
            {mainLoading ? (
              <Loader height="300px" />
            ) : comparisonData?.length > 0 ? (
              <Grid>
                <ComparisonTable
                  columns={COMP_LIB_TABLE_COLUMNS}
                  rowsData={comparisonData}
                  handleRowClick={handleRowClick}
                />
                <Box className={classes.pagination}>
                  <Pagination
                    count={pageCount}
                    page={tablePageNumber}
                    boundaryCount={1}
                    color="primary"
                    size="small"
                    shape="circular"
                    onChange={handlePagination}
                  />
                </Box>
              </Grid>
            ) : (
              <Grid className={classes.noDataGrid}>
                <NoDoc />
                <Typography
                  fontSize="16px"
                  fontType="semiBold"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  margin="16px 0px 10px 0px"
                >
                  {card.noData.title}
                </Typography>
                <Typography
                  fontSize="14px"
                  fontType="regular"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                >
                  {card.noData.subTitle}
                </Typography>
              </Grid>
            )}
          </Grid>
        }
      />
    );
  };

  const SummaryOfFindings = () => {
    return (
      <ProvisionMatrix
        title="Summary"
        subTitle=""
        showFilters={false}
        matrixColumns={summaryColumns}
        matrixData={summaryOfFindings}
        showRegenerate={false}
        groupByCategory={false}
      />
    );
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Grid className={classes.root}>
          <Breadcrumbs itemList={breadcrumbItems} />
          <hr className={classes.hr} />
          <Grid className={classes.titleGrid}>
            <Typography
              fontType="semiBold"
              fontSize="18px"
              textColor={patientAccessTheme.palette.text.highemphasis}
            >
              {`${serviceAgreement} Agreement for`}
            </Typography>
            <Grid className={classes.dateGrid}>
              <Typography
                fontType="semiBold"
                fontSize="14px"
                textColor={patientAccessTheme.palette.text.highemphasis}
              >
                {`${renewal?.month} ${renewal?.year}`}
              </Typography>
            </Grid>
          </Grid>
          <TabSelection
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={handleSelectedIndex}
            tabList={toolsTabs.map((tab) => tab.title)}
          />
          <Grid className={classes.tabContent}>
            {tabLoading ? <Loader /> : getTabsContent()}
          </Grid>
          <Snackbar
            {...snackbarState}
            handleClose={handleCloseSnackBar}
            vertical="bottom"
            horizontal="right"
          />
        </Grid>
      )}
    </>
  );
};

export default RenewalDetailsPage;
